import {fetchLocationMetrics} from "../network/InductNetworkAPI";

export const InductAreaReducer = (state, action) => {
    switch (action.type) {
        case "LOAD_VIEW":
            const {filter, dispatcher} = action.data;
            fetchLocationMetrics(filter, dispatcher)
            return state
        case "INDUCT_AREA_INSIGHT":
            return {...state, ...action.data}
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/components/induct/reducers/InductAreaReducer.js